/** Parse a comma/whitespace-separated recipient list into trimmed entries. */
export function parseRecipients(s: string): string[] {
  return s.split(/[,\s]+/).map((x) => x.trim()).filter(Boolean);
}

const E164 = /^\+[0-9]{7,15}$/;

/** Mirror of the Firestore rules validation; returns an error message or null. */
export function validateRecipients(list: string[]): string | null {
  if (list.length > 10) return 'At most 10 SMS recipients (Quo per-send cap).';
  const bad = list.find((r) => !E164.test(r));
  if (bad) return `"${bad}" is not E.164 (expected +14155550123 format).`;
  return null;
}
